import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserStoryRTMDashboard from "./UserStoryRTMDashboard";
import TestRTMDashboard from "./TestRTMDashboard";
import ExecutionRTMDashboard from "./ExecutionRTMDashboard";
import DefectAnalyticsDashboard from "./DefectAnalyticsDashboard";

const AIAnalyticsDashboard = ({ data, templateType, onClose }) => {
  const renderDashboard = () => {
    switch (templateType) {
      case "storyRtm":
        return <UserStoryRTMDashboard data={data} />;
      case "testRtm":
        return <TestRTMDashboard data={data} />;
      case "executionRtm":
        return <ExecutionRTMDashboard data={data} />;
      case "defectAnalytics":
        return <DefectAnalyticsDashboard data={data} />;
      default:
        return (
          <Box p={3} textAlign="center">
            <Typography variant="h6">Generic Analytics Dashboard</Typography>
            <Typography color="textSecondary">
              Detailed dashboard for {templateType} is coming soon.
            </Typography>
          </Box>
        );
    }
  };

  const getTitle = () => {
    let cyclePrefix = "";
    if (templateType === "executionRtm" && data && data.length > 0) {
      const cycleKey = Object.keys(data[0]).find(
        (k) => k.toLowerCase() == "cycle name",
      );
      if (cycleKey && data[0][cycleKey] && data[0][cycleKey] !== "N/A") {
        cyclePrefix = `${data[0][cycleKey]} - `;
      }
    }

    const titles = {
      storyRtm: "User Story RTM Analytics",
      testRtm: "Test RTM Analytics",
      executionRtm: `${cyclePrefix}Execution Analytics`,
      defectAnalytics: "Defect Insights & Analytics",
    };
    return titles[templateType] || "AI Analytics Dashboard";
  };

  const handleDownloadPDF = () => {
    window.print(); // Simple professional way without adding heavy libraries
    // In a real app, we'd use jspdf/html2canvas
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "#f5f7fa",
        minHeight: "90vh",
        // Thin scrollbar styles
        "& *::-webkit-scrollbar": {
          height: "6px",
          width: "6px",
        },
        "& *::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1",
          borderRadius: "10px",
        },
        "& *::-webkit-scrollbar-thumb": {
          backgroundColor: "#c1c1c1",
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: "#a8a8a8",
          },
        },
        "& *": {
          scrollbarWidth: "thin",
          scrollbarColor: "#c1c1c1 #f1f1f1",
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "#1a237e" }}>
            {getTitle()}
          </Typography>
          {/*   <Typography variant="body2" color="textSecondary">
            QA Insights and Analytics
          </Typography>  */}
        </Box>
        <Box display="flex" alignItems="center">
          {/* <UIRTMButton 
            title="Export PDF"
            variant="text" 
            icon={<PictureAsPdfIcon sx={{ fontSize: "1rem" }} />} 
            onClick={handleDownloadPDF}
          /> */}
          <IconButton onClick={onClose} size="small" sx={{ ml: 1 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {renderDashboard()}

      <Box mt={4} pt={2} borderTop="1px solid #e0e0e0" textAlign="center">
        <Typography variant="caption" color="textSecondary">
          © Charles Hudson Technology Solutions - QA Analytical Report
        </Typography>
      </Box>
    </Box>
  );
};

export default AIAnalyticsDashboard;
